import { render, staticRenderFns } from "./form.vue?vue&type=template&id=399b5d33&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('399b5d33')) {
      api.createRecord('399b5d33', component.options)
    } else {
      api.reload('399b5d33', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=399b5d33&", function () {
      api.rerender('399b5d33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/client/components/form.vue"
export default component.exports